import React from 'react';
import Form from 'react-bootstrap/Form';
import MASpinner from '../../common/MASpinner';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { healthInsurerSingleUpdate } from '../../../lib/redux/actions/healthInsurer';
import { renderField } from '../../../lib/helper/form';
import { addToast } from '../../../lib/redux/actions/toast';
import { Row, Col } from 'react-bootstrap';

const mapStateToProps = (state, props) => {
  const initialValues = {
    name: props.healthInsurer ? props.healthInsurer.name : '',
  };
  return {
    isUpdatingHealthInsurer: state.healthInsurer.isUpdatingHealthInsurer,
    initialValues,
  };
};

const mapDispatchToProps = {
  healthInsurerSingleUpdate,
  addToast,
};

class HealthInsurerForm extends React.Component {
  onSubmit = async (values) => {
    if (this.props.readOnly) {
      return;
    }

    const { healthInsurerSingleUpdate, addToast, healthInsurer } = this.props;

    try {
      await healthInsurerSingleUpdate(
        {
          name: values.name,
        },
        healthInsurer.id,
      );
      addToast('Health Insurer updated successfully', true, false);
    } catch (error) {
      addToast('Failed to update health insurer', false, true);
      throw error;
    }
  };

  render() {
    const { handleSubmit, error, pristine, submitting, isUpdatingHealthInsurer, readOnly = false } = this.props;

    return (
      <div>
        <h2 className="crud__section-header">Health Insurer Details</h2>

        {error && <div className="alert alert-danger">{error}</div>}

        <Form onSubmit={handleSubmit(this.onSubmit)}>
          <Row>
            <Col xs={12}>
              <Field className="mb-3" name="name" label="Health Insurer Name" id="name" type="text" component={renderField} disabled={readOnly} required />
            </Col>
          </Row>

          {!readOnly && (
            <>
              {isUpdatingHealthInsurer ? (
                <MASpinner msg="Updating Health Insurer..." />
              ) : (
                <button type="submit" disabled={pristine || submitting} className="btn btn-primary">
                  Update Health Insurer
                </button>
              )}
            </>
          )}
        </Form>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm({
    form: 'HealthInsurerForm',
    enableReinitialize: true,
  })(HealthInsurerForm),
);
